module.exports = __webpack_public_path__ + "img/rewards-banner-illustration.c0dcc9af.png";